import { Alert } from 'foundations-components/transitional/components/Alert';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddOnAlert = ({
  productApiName,
  ownedQuantity,
  isHubSpotCredits,
  includedQuantity
}) => {
  const titleString = I18n.text(`pricing-pages-ui.productNamesV2.${productApiName}.title`);

  // hubspot credits: user has both purchased credits and credits included with their subscription
  if (isHubSpotCredits && ownedQuantity && includedQuantity) {
    return /*#__PURE__*/_jsx(Alert, {
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.addOns.cards.alert.alertTitleOwnAndIncluded"
      }),
      marginBlockEnd: "1000",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.addOns.cards.alert.alertDescriptionOwnAndIncluded",
        options: {
          includedDefaultUnits: includedQuantity,
          ownedQuantity
        }
      })
    });
  }

  // hubspot credits: user only has credits included with their subscription (no purchased credits)
  if (isHubSpotCredits && includedQuantity) {
    return /*#__PURE__*/_jsx(Alert, {
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.addOns.cards.alert.alertTitleIncluded",
        options: {
          includedDefaultUnits: includedQuantity
        }
      }),
      marginBlockEnd: "1000"
    });
  }

  // other add-ons: user has purchased units of this add-on
  if (ownedQuantity) {
    return /*#__PURE__*/_jsx(Alert, {
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.addOns.cards.alert.alertTitleOwn",
        options: {
          ownedQuantity,
          title: titleString
        }
      }),
      marginBlockEnd: "1000"
    });
  }
  return null;
};